module.exports = __webpack_public_path__ + "img/transaction-blue.dc8d3057.svg";